import { render } from "./unreadNotifications.vue?vue&type=template&id=c3fc95c6"
import script from "./unreadNotifications.vue?vue&type=script&lang=js"
export * from "./unreadNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__